// extracted by mini-css-extract-plugin
module.exports = {"Header":"ModalDelete_Header__3mM4C","body":"ModalDelete_body__2XX0Z"};